/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './support.tpl.html';

angular.module('mobile.support', []).config([
  '$stateProvider',
  'VIEW_STATES',
  function ($stateProvider, VIEW_STATES) {
    $stateProvider
      .state(VIEW_STATES.MOBILE_SUPPORT, {
        abstract: true,
        views: {
          content: {
            templateUrl: 'mobile/support/support.tpl.html'
          }
        }
      })
      // The views that are rendered in the support view.
      .state(VIEW_STATES.MOBILE_SUPPORT_HOME, {
        url: '/support'
      });
  }
]);
